import { useMemo } from 'react';
import { useProject } from './projects/useProject';
import { Employee } from '@models/employee.model';

interface UseSuperintendentsReturn {
  superintendents: Employee[];
  loading: boolean;
  error: string | null;
}

export const useSuperintendents = (
  projectId: string,
): UseSuperintendentsReturn => {
  const { data: project, isLoading: loading, error } = useProject(projectId);

  const superintendents = useMemo(() => {
    if (!project?.superintendents) {
      return [];
    }
    return project.superintendents;
  }, [project?.superintendents]);

  return {
    superintendents,
    loading,
    error: error?.message || null,
  };
};
